import React, { Component } from "react";
import PropTypes from "prop-types";
import LoadingWrapper from "../../common/loading-wrapper";
import { StackedBarChart, DiscreteColorLegend, makeWidthFlexible } from "@unifiedpatents/euclid-react";
import { colorScaleCategorical } from "@unifiedpatents/euclid-react/lib/helpers/colors";
import { orderBy } from "@unifiedpatents/euclid-react/lib/helpers/preprocessors";
import { withChartConfig } from "../../common/chart-config-hoc";
const FlexibleStackedBarChart = withChartConfig(makeWidthFlexible(StackedBarChart));
import { getDocumentsByField, getDocumentsByTwoFields } from "../../../services/api-repo";
import { toTitleCase } from "../../../helpers/converters";
import * as Colors from "@unifiedpatents/euclid-react/lib/helpers/colors";

const colorScale = colorScaleCategorical();

const COLOR_MAP = {
  avc: Colors.grey500,
  hevc: Colors.orange500,
  vvc: Colors.blue500,
  approved: Colors.blue500,
  "not approved": Colors.grey400
};

class FieldAggregation extends Component {
  static propTypes = {
    field: PropTypes.string.isRequired,
    field2: PropTypes.string,
    size: PropTypes.number.isRequired,
    filter: PropTypes.object,
    esUrl: PropTypes.string.isRequired,
    tickFormatY: PropTypes.func,
    fieldsWideLabel: PropTypes.arrayOf(PropTypes.string),
    margin: PropTypes.object
  };

  static defaultProps = {
    filter: {},
    fieldsWideLabel: [],
    margin: { left: 60, right: 20, top: 60, bottom: 20 }
  };

  state = {
    data: [],
    dataRaw: [], // for csv export
    loading: true
  };

  componentDidMount() {
    this._isMounted = true;
    this._getData(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (JSON.stringify(nextProps) !== JSON.stringify(this.props)) {
      this._getData(nextProps);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { loading } = this.state;
    const { field2 } = this.props;
    return (
      <LoadingWrapper loading={loading} spinSize="large" style={{ minHeight: 200 }}>
        {this._renderChart()}
        {field2 ? this._renderLegend() : null}
      </LoadingWrapper>
    );
  }

  _renderChart = () => {
    const { data } = this.state;
    const { field, field2, size, fieldsWideLabel, tickFormatY, margin } = this.props;
    let labelWidth = fieldsWideLabel.includes(field) ? 300 : 150;
    if (tickFormatY) {
      const maxLabelLength = data => {
        let maxLength = 0;
        data.length &&
          data[0].v.forEach(obj => {
            if (tickFormatY(obj.k).length > maxLength) {
              maxLength = tickFormatY(obj.k).length;
            }
          });
        return maxLength;
      };
      labelWidth = maxLabelLength(data) * 8;
    }
    const height = (500 * size) / 20;
    return (
      <FlexibleStackedBarChart
        orientation="vertical"
        data={orderBy(data, undefined, "__total__")}
        height={height}
        margin={{ ...margin, left: labelWidth }}
        colorMap={field2 ? COLOR_MAP : undefined}
        tickFormatY={tickFormatY}
        tickTotalX={5}
      />
    );
  };

  _renderLegend = () => {
    const field2Keys = this.state.data.map(d => d.k);
    return field2Keys.length > 0 && <DiscreteColorLegend orientation="horizontal" items={field2Keys.map(key => ({ title: key, color: COLOR_MAP[key] }))} colors={[...field2Keys].map(colorScale)} />;
  };

  _getData = props => {
    if (this._isMounted) this.setState({ loading: true });
    const { field2, field, filter, esUrl, size } = props;
    const apiCall = field2 ? getDocumentsByTwoFields : getDocumentsByField;
    const apiCallPromise = field2 ? apiCall(esUrl, filter, field, field2, size) : apiCall(esUrl, filter, field, size);
    apiCallPromise
      .then(res => {
        if (this._isMounted)
          this.setState({
            data: this._reformatData(res),
            dataRaw: res,
            loading: false
          });
      })
      .catch(() => {
        if (this._isMounted)
          this.setState({
            data: [],
            dataRaw: [],
            loading: false
          });
      });
  };

  _reformatData = data => {
    const { field2 } = this.props;
    if (field2) {
      let res = {};
      data.reverse().forEach(e => {
        e.value.forEach(e2 => {
          if (!res[e2.key]) res[e2.key] = [];
          res[e2.key].push({ k: toTitleCase(String(e.key)), v: e2.doc_count });
        });
      });
      return Object.entries(res)
        .map(([k, v]) => ({ k, v }))
        .sort((a, b) => (a.k < b.k ? -1 : 1));
    } else {
      return data.length == 0 ? [] : [{ k: "Count", v: data.reverse().map(e => ({ k: toTitleCase(String(e.key)), v: e.doc_count })), color: Colors.blue400 }];
    }
  };
}

export default FieldAggregation;
